import React, { FC } from 'react'
import { Datagrid, EmailField, Filter, FilterProps, List, ListProps, SearchInput, TextField } from 'react-admin'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'

const VendorFilter: FC<Omit<FilterProps, 'children'>> = (props) => (
  <Filter {...props}>
    <SearchInput source="company_name,code,email,tel,fax" alwaysOn />
  </Filter>
)

const VendorsList: FC<ListProps> = (props) => {
  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - Vendors`} />
      <RouteBreadcrumbs {...props} />
      <List
        {...props}
        perPage={25}
        sort={{ field: 'code', order: 'ASC' }}
        filters={<VendorFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="edit">
          <TextField source="company_name" />
          <TextField source="code" />
          <TextField source="country" />
          <EmailField source="email" />
          <TextField source="tel" />
          <TextField source="fax" />
        </Datagrid>
      </List>
    </>
  )
}

export default VendorsList
